import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.service';
import { selectStepById } from '../../selectors/process.selectors';
import * as Defaults from '../../default-process-fields';
import { ProcessStepModel } from '../../process.model';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mj-process-interview',
  templateUrl: './process-interview.component.html',
  styleUrls: ['./process-interview.component.scss'],
})
export class ProcessInterviewComponent implements OnInit, OnDestroy {
  @Input() stepOpenedUuid$;

  defaults = Defaults;
  @Output() processChanged = new EventEmitter();
  step: ProcessStepModel;

  @Input() stepId: number;
  isStepActive: boolean;
  private step$: Subscription;

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.step$ = this.store
      .pipe(select(selectStepById(this.stepId)))
      .subscribe(data => {
        if (data) {
          this.step = data;

          if (data && data.actions.length === 0) {
            this.processChanged.emit({
              id: this.stepId,
              changes: {
                actions: [this.defaults.DefaultActions[0]],
              },
            });
          }

          this.setDefaultMessage();
        }
      });

    this.stepOpenedUuid$.subscribe(uuid => {
      this.isStepActive = uuid === this.step.uuid;
    });
  }

  ngOnDestroy(): void {
    if (this.step$) {
      this.step$.unsubscribe();
    }
  }

  toggleEnabled(e) {
    e.stopPropagation();
    this.processChanged.emit({
      id: this.stepId,
      changes: { enabled: !this.step.enabled },
    });
  }

  updateAction(i, changes: {}) {
    const newAction = { ...this.step.actions[i] };
    const key = Object.keys(changes)[0];
    newAction[key] = changes[key];

    const newArr = this.step.actions.map((action, index) => {
      if (index === i) {
        return newAction;
      } else {
        return action;
      }
    });

    this.processChanged.emit({
      id: this.stepId,
      changes: { actions: newArr },
    });
  }

  setDefaultMessage() {
    if (this.step.actions[0] && !this.step.actions[0].message) {
      this.translate
        .get('step_interview_message')
        .pipe(take(1))
        .subscribe(msg => {
          const newArr = [...this.step.actions].map(elem => {
            return Object.assign({}, elem, { message: msg });
          });
          this.processChanged.emit({
            id: this.stepId,
            changes: { actions: newArr },
          });
        });
    }
  }
}
